function normalizedDate(value) {
  const parts = String(value || "").match(/(\d{4})\D?(\d{2})\D?(\d{2})/);
  return parts ? `${parts[1]}-${parts[2]}-${parts[3]}` : "";
}

const CUSTOMS_NOTICE_DETAIL_URL =
  "https://unipass.customs.go.kr/csp/myc/custsppt/cmmn/NtarBrkdMtCtr/openMYC0605014Q.do";

/** 검증된 관세청 공지 식별자만 UNI-PASS 개별 원문 URL로 변환한다. */
export function customsNoticeOriginalUrl(noticeId) {
  const normalized = String(noticeId || "").trim();
  if (!/^\d{8,20}$/.test(normalized)) return "";
  return `${CUSTOMS_NOTICE_DETAIL_URL}?ntarId=${encodeURIComponent(normalized)}&upYn=`;
}

/** 서로 다른 공지 원천을 중복 제거한 뒤 날짜 내림차순으로 합친다. */
export function mergeNewsItems(...groups) {
  const seen = new Set();
  return groups
    .flatMap((group) => (Array.isArray(group) ? group : []))
    .map((item, index) => ({ item, index }))
    .filter(({ item }) => {
      if (!item) return false;
      const key = String(item.id || item.title || "").trim();
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .sort((a, b) => {
      const byDate = normalizedDate(b.item.date).localeCompare(normalizedDate(a.item.date));
      return byDate || a.index - b.index;
    })
    .map(({ item }) => item);
}
